import styled from "styled-components";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <Headers>
      <ul>
        <li>
          <Link to="/">درباره ما</Link>
        </li>
        <li>
          <Link to="/"> تماس با ما </Link>
        </li>
        <li>
          <Link to="/">چرا علی گشت</Link>
        </li>
        <li>
          <Link to="/blog">وبلاگ علی گشت</Link>
        </li>
        <li style={{ marginRight: "auto" }}>
          <Link to="/">راهنما</Link>
        </li>
        <li>
          <Link to="/">ورود</Link>
        </li>
        /
        <li>
          <Link to="/">ثبت نام</Link>
        </li>
        <li style={{ marginLeft: "50px" }}>
          <a href="/">
            <img src="/images/logo.png" alt="" />
          </a>
        </li>
      </ul>
    </Headers>
  );
};

export default Header;
const Headers = styled.div`
  background-color: #ffff;

  @media (max-width: 600px) {
    width: 100vw;
    overflow: hidden;
  }

  ul {
    display: felx;
    align-items: center;
    list-style: none;
    padding-left: 80px;

    li {
      margin: 2px 20px;
      font-size: 16px;
      font-weight: 500;

      a {
        text-decoration: none;
        color: rgba(0, 0, 0, 0.7);

        img {
          width: 90px;
          height: 70px;
        }
      }

      :nth-child(6),
      :nth-child(7),
      :nth-child(8){
        &::before{
          display: none;
        }

      }

      &::before {
        content: "";
        display: block;
        position: relative;
        border: 1px solid #2e2e2e;
        box-shadow: 0px 0px 5px #000;
        top: 26px;
        right: 0;
        transform-origin: right center;
        transform: scaleX(0);
        transition: all 250ms;
      }
      &:hover {
        &::before {
          transform: scaleX(1);
        }
      }
    }
  }
`;
